module.exports = __webpack_public_path__ + "static/media/icon-type.7041a03f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-type.svg
// module id = ./src/assets/images/icon-type.svg
// module chunks = 6